<template>
  <transition name="slide-down">
    <div v-if="visible" class="notice-bar">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: "GiftCardRedirectNotice",
  props: {
    message: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,
      default: false
    },
    disableShowNotice: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      visible: this.show
    };
  },
  mounted() {
    this.visible = true;

    setTimeout(() => {
      this.visible = false;
      this.disableShowNotice();
    }, 5000);
  }
};
</script>

<style scoped>
.notice-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: fit-content;
  background-color: #fffae6;
  color: #333;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  z-index: 10001;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* transition styles */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.6s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100%);
}
</style>
